import { getErrorMessage } from 'utils/errorUtils';

export const startLoading = (state) => {
  state.isLoading = true;
};

export const startFetching = (state) => {
  state.isFetching = true;
};

export const handleError = (state, action) => {
  state.isLoading = false;
  state.showError = true;
  state.error = getErrorMessage(action.error);
};
